import styled from "styled-components";
import { theme } from "ui";

export const Container = styled.div`
  max-height: 648px;
  overflow-y: auto;
`;

export const InstallmentsTitle = styled.h4`
  font-size: ${theme.typography.fontSize.sm.x5};
  font-weight: ${theme.typography.fontWeight["600"]};
  color: ${theme.colors.neutral["550"]};
`;
